import { css } from 'lit';

export default css`:host slot::slotted(:not([fs-accordion-item])){display:none}`;